// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedWorks_container__4Vcjy","heading":"SelectedWorks_heading__1Jw3E"};